class ArticleEditDrag {
    constructor(dragNDropInstance, translator, toastNotifier = null) {
        if (!dragNDropInstance) throw new Error('DragNDrop instance is required');
        if (!translator) throw new Error('ArticleEditDrag: translator is required');
        this.dragNDrop = dragNDropInstance;
        this.translator = translator;
        this.toastNotifier = toastNotifier;
        this.persist = null;
    }

    /** Configured by the Article adapter; transport belongs to FormZeroAjax. */
    setPersist(callback) {
        this.persist = callback;
    }

    async dropCallback(parent) {
        const type = parent.getAttribute('data-type');
        if (!type) return;
        const form = parent.closest('form[data-fz-token]');
        if (!form || typeof this.persist !== 'function') {
            throw new Error('Article editor is not initialized');
        }
        const ownerId = ['section', 'image', 'attachment', 'video'].includes(type)
            ? form.dataset.fzArticleId
            : /^\w+-(\d+)$/.exec(parent.id)?.[1];
        if (!ownerId) throw new Error('Missing reorder owner');

        // Only the children that can be dragged are included. No placeholders,
        // hidden inputs or unrelated nested rows may alter the rank list.
        const ids = [...parent.children]
            .filter((element) => element.matches(`${this.dragNDrop.contents}[data-object-id]`))
            .map((element) => element.getAttribute('data-object-id'));
        try {
            await this.persist(form, type, ownerId, ids);
        } catch (error) {
            // DragNDrop rolls back the DOM order after this rejection.
            this.lastError = error;
            const translated = this.translator.trans('article.dragUpdateError', {error: error.message});
            const message = translated === 'article.dragUpdateError'
                ? `Impossibile salvare il nuovo ordine: ${error.message}` : translated;
            if (this.toastNotifier) this.toastNotifier.error(message);
            else if (typeof window !== 'undefined' && typeof window.alert === 'function') window.alert(message);
            throw error;
        }
    }

    init(root = document) {
        this.dragNDrop.init((parent) => this.dropCallback(parent), root);
    }
}

export default ArticleEditDrag;
